import { render, staticRenderFns } from "./MarketplaceInfo.vue?vue&type=template&id=4384fd71&"
import script from "./MarketplaceInfo.vue?vue&type=script&lang=js&"
export * from "./MarketplaceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports